/* Number formatting helpers — precision-aware (Decimal-as-string from backend). */

export function fmtMoney(value, decimals = 2) {
    if (value === null || value === undefined || value === "") return "$0.00";
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return `$${n.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })}`;
}

export function fmtPct(value, decimals = 2) {
    if (value === null || value === undefined || value === "") return "0%";
    const n = Number(value);
    if (Number.isNaN(n)) return `${value}%`;
    return `${n.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })}%`;
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString();
    } catch {
        return iso;
    }
}
